import axios from 'axios';

const api = '/api/download-document';

export const getDocuments = () => {
  return axios.get(`${api}?cacheBuster=${new Date().getTime()}`);
};

export const uploadDocument = file => {
  const formData = new FormData();
  formData.append('file', file);

  return axios.post(`${api}/upload`, formData, {
    headers: {
      'Content-Type': 'multipart/form-data',
    },
  });
};

export const downloadDocument = async (id, originalname) => {
  const response = await axios.get(`${api}/download/${id}`, {
    responseType: 'blob', // Important for binary data
  });

  // Create a URL for the blob
  const url = window.URL.createObjectURL(new Blob([response.data]));
  const link = document.createElement('a');
  link.href = url;
  link.setAttribute('download', originalname); // Set the original file name
  document.body.appendChild(link);
  link.click();
  link.remove();
};

export const deleteDocumentById = contractDocument => {
  return axios.delete(`${api}/${contractDocument.id}`);
};
